import { makeStyles } from "@material-ui/core/styles";

const appointmentFormStyle = makeStyles((theme) => ({
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },

  buttons: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
  myFormControlLabelRoot: {
    marginLeft: "0px",
    marginRight: "0px",
    "&:hover": {
      background: "#F8FBFD !Important",
      border: "1px solid #007BFF !Important",
      color: "#007BFF !Important",
    },
  },
  formDiv: {
    padding: "1rem 1.5rem  1rem  1.5rem",
    // paddingBottom: "24px"
  },

  radioBox: {
    position: "relative",
    display: "grid !important ",
    gridTemplateColumns: "auto auto auto",
    paddingTop: "1.5rem",
    paddingBottom: "1.5rem",
    "&.twoColumns": {
      gridTemplateColumns: " repeat(2, 1fr)",
      gap: "1.5rem",
    },
    "&.threeColumns": {
      display: "flex!important",
      flexDirection: "row",
      flexWrap: "wrap",
      width: "fit-content",
      gap: "0.625rem",
    },
  },
  sheetInput: {
    "&.MuiSheet-root": {
      padding: "4px 13px",
      width: "fit-content",
      textAlign: "center",
    },
    "& .css-1fjq3ub-JoyRadio-root": {
      fontSize: "1rem",
      lineHeight: "2rem",
      // fontFamily: ["Poppins", "sans-serif"].join(","),
      fontFamily: ["Verdana", "sans-serif"].join(","),
    },
    "& .css-l3zqaq-JoyRadio-input": {
      position: "static",
    },
    "& .Joy-checked": {
      // fontFamily: ["Poppins", "sans-serif"].join(","),
      fontFamily: ["Verdana", "sans-serif"].join(","),
      borderColor: "#007bff",
      borderWidth: "1px",
      backgroundColor: "#e2f0ff",
      fontSize: "1rem",
      lineHeight: "2rem",
      "--variant-borderWidth": "1px",
    },
    "& .css-1p8kzi6": {
      color: " #007BFF",
    },
    "& .css-146vgrr": {
      fontSize: "16px",
      // fontFamily: "Poppins",
      fontFamily: "Verdana",
      "--Radio-size": "2rem",
    },
    "& .css-v2ra2r-JoyRadio-action": {
      "--variant-borderWidth": "1px",
    },
    "& .css-iqfjqt-JoyRadio-label": {
      color: "#007BFF !important",
    },
  },
  sheetRadioOpt: {
    "& .MuiRadio-action": {
      borderRadius: ".5rem",
    },
  },
  formDivWithHeight: {
    padding: "1rem 1.5rem 1rem 1.5rem",
    position: "inherit",
    height: "auto",
  },
  textFieldDiv: {
    "& div.MuiInputBase-root": {
      border: "solid 0px #666666",
      // fontFamily: ["Poppins", "sans-serif"].join(","),
      fontFamily: ["Verdana", "sans-serif"].join(","),
      // padding: ".5rem 1rem !important",
    },
    "& input:-internal-autofill-selected": {
      border: "solid 0px #666666",
      WebkitBoxShadow: "0 0 0 100px #fff inset",
    },
    "& .MuiFormLabel-root": {
      // top: '3px',
      border: "solid 0px #666666",
      // fontFamily: ["Poppins", "sans-serif"].join(","),
      fontFamily: ["Verdana", "sans-serif"].join(","),
    },
    "&.MuiAutocomplete-root": {
      "& .MuiOutlinedInput-root": {
        padding: "0 !important",
        fontFamily: ["Verdana", "sans-serif"].join(","),
      },
    },
    "& div.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      border: "solid 0px #666666",
      padding: "0.813rem 1rem !important",
      fontFamily: ["Verdana", "sans-serif"].join(","),
    },
    "& .MuiIconButton-root": {
      border: "solid 0px #666666",
      padding: "0.313rem 0.625rem 0 .25rem",
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      border: "solid 0px #666666",
      // top: 0,
    },
    // text fields spacing
    "& div.MuiInputBase-root Input.MuiInputBase-input": {
      border: "solid 0px #666666",
      padding: "14px 14px 12px",
      fontFamily: ["Verdana", "sans-serif"].join(","),
      // padding: "0px !important",
      // height: "2rem",
    },
    "& .MuiOutlinedInput-root": {
      border: "solid 0px #666666",
      borderRadius: ".625rem",
    },
    "& .MuiIconButton-edgeEnd": {
      border: "solid 0px #666666",
      marginRight: "0px",
    },
  },

  orDivideSpan: {
    flexGrow: 1,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    margin: "0 10px",
  },
  flexFieldWrapper: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    //gap: "1.5rem",
    flexGrow: "1",
  },
  ButtonAddress: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexFieldWrap: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "1.5rem",
    flexGrow: "1",
    "& .childField": {
      flexGrow: 1,
      width: "100%",
      maxWidth: "100%",
      "& .MuiFormControlLabel-root": {
        gap: "12px",
        marginLeft: "0px",
        marginRight: "50px",
      },
      "& .css-ahj2mt-MuiTypography-root": {
        // fontFamily: "Poppins !important",
        fontFamily: "Verdana !important",
      },
      "& .MuiTypography-root": {
        // fontFamily: "Poppins !important",
        fontFamily: "Verdana !important",
      },
      "& .MuiTypography-root-body1": {
        // fontFamily: "Poppins !important",
        fontFamily: "Verdana !important",
      },
    },
    "& .childLabel": {
      flexGrow: 1,
      width: "100%",
      maxWidth: "100%",
    },
    [theme.breakpoints.up(600)]: {
      "& .childField": {
        maxWidth: "60%",
        width: "auto",
      },
    },
  },
  formTitleTypoGraphy: {
    // padding: "24px",
    paddingBottom: "0px",
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    // fontFamily: ["Poppins", "sans-serif"].join(",")
    fontFamily: ["Verdana", "sans-serif"].join(","),
  },
  formTitleHr: {
    height: "3px",
    width: "24px",
    border: "none",
    background: theme.palette.primary.main,
    margin: ".375rem auto 0",
  },
  formTitleDiv: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    flexDirection: "column",
    gap: "1rem 1rem",
    margin: "auto",
    // marginTop: "10px",
    "& .MuiTypography-root": {
      // fontFamily: "Poppins !important",
      fontFamily: "Verdana !important",
    },
  },

  formAccountDiv: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  formInstructionTypo: {
    fontWeight: "400",
    fontSize: "16px",
    margin: "0px",
    lineHeight: "32px",
    color: "#4D4F59",
  },
  formDbResponseTypo: {
    fontWeight: "400",
    fontStyle: "italic",
    fontSize: "16px",
    margin: "0px",
    lineHeight: "24px",
    color: "#6C6F7C",
  },
  note: {
    fontWeight: "bold",
    padding: "15px 0px 15px 0px",
  },
  noteSpan: {
    fontWeight: "500",
  },
  formAddressRadio: {
    "& span.MuiButtonBase-root": {
      padding: "0px !important",
      marginRight: "12px !important",
      height: "20px",
      width: "20px",
      background: "#F2F5FB",
      border: "1px solid #C5CEE0",
    },
    "&.MuiFormControlLabel-root": {
      marginLeft: "0",
    },
  },
  addressAddHeading: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    justifyContent: "space-between",
  },

  boxWrapper: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    flexFlow: "column",
    height: "100%",
    // minHeight: "80vh",
    position: "relative",
    color: "#000000",
    "& .justifyBetween": {
      justifyContent: "space-between",
    },

    // "& .MuiStepConnector-root": {
    //   marginTop: "-1.438rem",
    // },
  },

  h100: {
    overflowY: "auto",
    height: "100%",
  },
  footer: {
    position: "fixed",
    left: "0",
    bottom: "0",
    width: "100%",
  },

  checkBoxClass: {
    "& .MuiFormControlLabel-root": {
      gap: "12px!important",
      marginLeft: "0px",
      "& .MuiButtonBase-root": {
        color: theme.palette.primary.main,
      },
    },
  },
  checkBoxConfirm: {
    "& .MuiFormControlLabel-root": {
      gap: "0px!important",
      marginLeft: "-11px",
    },
  },
  checkbox: {
    color: theme.palette.primary.main,

    "&:checked": {
      color: theme.palette.primary.main, // Set the desired color for the checked state
    },
    "&:hover": {
      backgroundColor: "#fff!important",
    },
  },

  selectMenuList: {
    height: "378px",
  },
  calenderWrap: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    flexFlow: "column",
    justifyContent: "space-between",
    height: "100%",
    "& .react-calendar": {
      width: "100%",
      height: "auto",
      border: "none",
      // fontFamily: "Poppins !important"
      fontFamily: "Verdana !important",
    },
    "& .react-calendar__tile--now": {
      // background: theme.palette.primary.main,
      // color: "#ffff !important",
      border: `1px solid ${theme.palette.primary.main} !important`,
      background: "none",
    },

    "& button.react-calendar__tile.react-calendar__tile--now::after": {
      content: '""',
      width: "6px",
      height: "6px",
      position: "absolute",
      marginTop: "20px",
      borderRadius: "50%",
      border: `0px solid }`,
    },
    "& .react-calendar__tile--now:enabled:hover": {
      border: `0px solid`,
      background: "none",
    },

    "& .react-calendar__navigation__arrow": {
      display: "none",
    },
    "& .react-calendar__month-view__weekdays": {
      textTransform: "capitalize",
      marginBottom: "0px",
      fontSize: "12px",
      fontWeight: "500",
    },
    "& .react-calendar__month-view__days__day--weekend": {
      color: "#1F2327",
    },
    "& .react-calendar__month-view__days__day--neighboringMonth": {
      opacity: "0.3",
    },
    "& .react-calendar__tile--active": {
      background: `#e01c34 !important`,

      color: "#FFFFFF !important",
    },
    "& .react-calendar__navigation": {
      height: "70px",
    },

    "& .react-calendar__navigation__prev-button": {
      display: "block !important",
      fontSize: "2rem",
      background: "none",
    },
    "& .react-calendar__navigation__next-button": {
      display: "block !important",
      fontSize: "2rem",
      background: "none",
    },

    "& .react-calendar__navigation": {
      justifyContent: "center",
      margin: "1rem .5rem 1rem .5rem",
      justifyContent: "center",
      "& .react-calendar__navigation__label": {
        marginLeft: "0rem",
        paddingLeft: "24px",
        paddingRight: "24px",
        flexGrow: "0",
        pointerEvents: "none",
      },
      "& button:enabled:hover": {
        /* backgroundColor: "#ffff",*/
      },

      "& button": {
        // marginLeft: "1.5rem",
        flexGrow: "0 !important",
        "&:hover": {
          backgroundColor: "white",
        },
        "&:disabled": {
          backgroundColor: "#fff",
        },
      },
    },
    "& .react-calendar__navigation__label__labelText": {
      fontWeight: "300",
      fontSize: "2rem",
      // fontFamily: "Poppins !important",
      fontFamily: "Verdana !important",
      lineHeight: "40px",
      whiteSpace: "nowrap",
      color: " #1f2327",
    },
    "& .react-calendar__month-view__weekdays__weekday": {
      padding: "1.5 rem",
    },
    "& .react-calendar__month-view__days": {
      display: "grid !important",
      gridTemplateColumns: "auto auto auto auto auto auto auto !important",
      gap: "1rem 2rem",
      width: "100%",
      margin: "auto",
      marginBottom: "0.5rem",
      padding: ".75rem 1.5rem",
      justifyContent: "space-between",
    },

    "& .available": {
      background: "#FFFFFF",
      // border: `1px solid ${theme.palette.primary.main}`,
      color: "#007BFF",
    },
    "& abbr[title]": {
      textDecoration: "none",
    },
    "& .css-ahj2mt-MuiTypography-root": {
      // fontFamily: "poppins !important",
      fontFamily: "Verdana !important",
    },
  },

  calenderField: {
    "&react-calendar__navigation__label__labelText": {
      color: "#000",
      width: "2rem",
      height: "2rem",
      borderRadius: "50%",
      padding: "1rem 0",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1rem",
      fontFamily: ["arial", "sans-serif"].join(","),
      fontWeight: "500",
    },

    timeSlotdiv: {
      background: "#F2F0FA",
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
      paddingTop: "1rem",
      paddingBottom: "0rem",
      height: "100%",
    },

    "& button.react-calendar__tile": {
      color: "#000",
      width: "2rem",
      height: "2rem",
      borderRadius: "50%",
      padding: "1rem 0",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1rem",
      // fontFamily: "Poppins !important",
      fontFamily: "Verdana !important",
      fontWeight: "500",
    },
    "& .react-calendar__tile:disabled": {
      backgroundColor: "#fff",
      border: `0px solid ${theme.palette.primary.main}`,
    },

    "& .react-calendar__navigation__label": {
      background: "transparent",
    },

    "&. react-calendar__navigation__prev-button,react-calendar__navigation__next-button": {
      fontSize: "2rem",
      background: "transparent",
      display: "block !important",
    },
  },

  timeSlotdiv: {
    background: "#F2F0FA",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    paddingTop: "1rem",
    paddingBottom: "0rem",
    height: "100%",
  },

  selectTimeSlotText: {
    color: "#6C6F7C",
    fontSize: "0.93rem",
    lineHeight: "1.5rem",
  },

  scrollCardDiv: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto" /* Enable horizontal scrolling */,
    overflowY: "hidden",
    whiteSpace: "nowrap" /* Prevent text from wrapping */,
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  themeBtn: {
    "&.MuiButton-root": {
      padding: ".5rem .75rem !important",
      borderRadius: " 500px !important",
      fontWeight: "600",
      fontSize: ".875rem",
      lineHeight: "1rem",
      cursor: "pointer",
      marginLeft: ".25rem",
      marginRight: ".25rem",
      transition: "all 300ms ease",
      // textTransform: "none",
      // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)',
      "&.btnLarge": {
        padding: "1rem 1.5rem !important",
        fontSize: "1.125rem",
        color: "#1F2327",
      },
      "&.outlined": {
        background: "#E2F0FF",
        color: "#007BFF",
        border: "1px solid #007BFF",
        "&:hover": {
          background: "#a8cff9",
        },
      },
      "&.newAddress": {
        width: "175px",
      },
      "&.filled": {
        padding: ".75rem 1.125rem !important",
        background: "#007BFF",
        color: "#fff",
        border: "1px solid #007BFF",
        "&:hover": {
          background: "#0361c6",
        },
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
      },
      "&.primary": {
        background: "#007BFF",
        color: "#fff",
        border: "1px solid #007BFF",
        "&:hover": {
          background: "#0361c6",
        },
        "&.Mui-disabled": {
          opacity: "0.5",
        },
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
      },
      "&.grayBtn": {
        padding: ".75rem 1.125rem !important",
        background: "#edf1f7",
        color: "#fff",
        border: "1px solid #edf1f7",
        "&:hover": {
          background: "#0361c6",
        },
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
      },
      "&.whiteBtn": {
        background: "#ffffff",
        textTransform: "none",
        color: "#1F2327",
        border: "1px solid #ffffff",
        "& .MuiSvgIcon-root": {
          color: "#007BFF",
        },
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
      },
      "&.serviceType": {
        fontSize: "1.125rem",
        padding: "1rem 1.5rem !important",
        fontWeight: "600",
        letterSpacing: " 0.05em",
        background: "#ffffff",
        color: "#000000",
        border: "1px solid #ffffff",
        textTransform: "capitalize",
        "&:hover": {
          background: "rgba(226, 240, 255, 1)",
          border: "1px solid #007BFF",
          color: "#007BFF",
        },
        "& .MuiButton-startIcon": {
          height: "20px",
          width: "20px",
        },
      },
      "&.Mui-disabled": {
        // opacity: "0.4",
      },
      "& .svg-inline--fa": {
        fontSize: "0.813rem !important",
      },
    },
  },
  serviceIssues: {
    "&.MuiButtonBase-root": {
      // fontFamily: "Poppins !important",
      fontFamily: "Verdana !important",
      background: "#F8FBFD",
      color: "black",
      border: "1px solid #D3D7E1",
      borderRadius: ".5rem",
      justifyContent: "space-between",
      fontSize: "1rem",
      lineHeight: "2rem",
      padding: ".5rem 1rem",
      fontWeight: "400",
      textTransform: "none",
    },
  },
  popupaddress: {
    width: "100%",
    padding: ".5rem",
    borderRadius: "1rem",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 14px 34px",
    background: "#fff",
    //maxWidth: "22.5rem",
    margin: "2rem 1.25rem auto",
  },
  popupcard: {
    width: "100%",
    padding: ".5rem",
    borderRadius: "1rem",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 14px 34px",
    background: "#fff",
    maxWidth: "22.5rem",
    margin: "auto 1.25rem",
  },
  overlay: {
    position: "absolute",
    width: "100%",
    height: "auto",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    cursor: "pointer",
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    // maxHeight:"max-content",
    // minHeight:'fit-content'
  },

  positionRelative: {
    position: "relative",
  },
  stepsProgessBar: {
    boxSizing: "border-box",
    minHeight: "88px",
    width: "100%",
    background: "#F5F8FB",
    borderBottom: "1px solid #DDE1EB",
    padding: "1rem 3.875rem 2.125rem",
    "& .MuiStepConnector-root": {
      minWidth: "3rem",
    },
    "& .MuiStepConnector-lineHorizontal": {
      borderTop: "1px dashed",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiStepIcon-text": {
      fill: "#000000", //#1F2327",
    },
  },
  stepWrap: {
    position: "relative",
    "& .MuiStepLabel-iconContainer": {
      paddingRight: "0",
    },
    "& .MuiStepLabel-labelContainer": {
      width: "100%",
      position: "absolute",
      left: "-8px",
      right: "0",
      margin: "0 auto",
      bottom: "-22px",
      minWidth: "68px",
    },
    "& .MuiStepLabel-root": {
      flexDirection: "column",
      gap: "9px",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active": {
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      color: "#000000",
    },
    "& .MuiStepLabel-label": {
      fontWeight: "400",
      fontSize: ".650rem",
      lineHeight: "1rem",
      textAlign: "center",
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      color: "#1f2327",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "white",
      border: "1px solid",
      borderRadius: "50%",
      "& .MuiStepIcon-text": {
        fill: "#000",
        fontWeight: "bold",
      },
    },
    "& .makeStyles-stepper-31": {
      padding: "1.5rem",
      color: "black",
      background: "#f5f8fb",
      borderBottom: "1px solid #dde1eb",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: theme.palette.primary.main,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 24,
      strokeWidth: 0.2,
      stroke: "#C5CEE0",
      width: "2rem",
      height: "2rem",
      borderRadius: "50%",
      strokeWidth: "0",
    },
    "& .MuiStepIcon-root": {
      color: "#ffffff",
    },
  },
  rectangle: {
    paddingTop: "6.813rem",
    paddingBottom: "2.125rem",
  },
  fixBox: {
    width: "6.25rem",
    display: "block",
    // fontFamily: "Poppins !important",
    fontFamily: "Verdana !important",
    fontStyle: "normal",
    fontWeight: "900",
    borderRadius: "1.5rem 0px",
    fontSize: "2rem",
    lineHeight: "2rem",
    marginLeft: "auto",
    paddingTop: "33px",
    marginRight: "auto",
    textAlign: "center",
    borderBottom: "10px solid #4ca2ff",
    borderRight: "10px solid #4ca2ff",
    height: "6.25rem",
    color: "white",
    background: "#007bff",
  },
  buttonsWrap: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    flexFlow: "column",
    gap: "10px",
    alignItems: "center",
  },
  headingFour: {
    paddingTop: ".5rem",
    textAlign: "center",
    // fontFamily: "Poppins !important",
    fontFamily: "Verdana !important",
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    color: "#1f2327",
  },
  headingSix: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    color: "#1f2327",
    // marginBottom: "1rem",
    "&.mb-4": {
      marginBottom: "1rem",
    },
  },

  errorMessage: {
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1.5rem",
    padding: "1rem 1.5rem",
  },

  textBreadcrumb: {
    fontSize: "0.813rem",
    color: " #007BFF",
    lineHeight: "1rem",
    display: "block",
    marginBottom: "1rem !important",
  },
  titleHr: {
    width: "24px",
    padding: "1px",
    marginTop: "4px",
    marginBottom: "0px",
    border: "none",
    background: theme.palette.primary.main,
    margin: ".375rem auto 0",
  },
  jobTypeTitleIcon: {
    height: "40px",
    width: "40px",
    "& svg": {
      height: "40px",
      width: "40px",
    },
  },
  okayBtn: {
    color: "black",
    textTransform: "none",
    fontWeight: "600",
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    padding: "1rem 1.5rem",
  },
  confirmBoxInfo: {
    display: "-ms-flexbox",
    display: "-webkit-flex ",
    display: "flex",
    alignItems: "flex-start",
    "& .MuiSvgIcon-root, svg": {
      marginRight: ".875rem",
      width: "1.25rem",
    },
  },
  w100: {
    width: "100%",
  },

  [theme.breakpoints.down(600)]: {
    stepsProgessBar: {
      maxWidth: "100%",
      overflowX: "auto",
      padding: "1rem 1.5rem 2.125rem",
      scrollPaddingInlineEnd: "35px",
    },
    calenderWrap: {
      "& .react-calendar__month-view__days": {
        gap: "0.5rem",
        padding: "0.75rem 1.5rem",
      },
      // "& .react-calendar__navigation__label": {
      //   marginLeft: "1rem",
      // },
      "& .react-calendar__navigation": {
        "& .react-calendar__navigation__label": {
          marginLeft: "0rem",
        },
        "& button": {
          marginLeft: "0rem",
        },
      },
    },
    titleHr: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    rectangle: {
      //paddingTop: "4rem",
    },
    formTitleDiv: {
      gap: "1rem",
    },
    flexFieldWrap: {
      gap: "1rem",
    },
    locationicon: {
      marginBottom: "0px !important",
    },
  },

  [theme.breakpoints.down(570)]: {
    calenderWrap: {
      "& .react-calendar__month-view__days": {
        gap: "0.5rem",
        padding: "0.75rem 1.1rem",
      },
    },

    flexFieldWrapper: {
      flexWrap: "wrap",
    },

    radioBox: {
      "&.threeColumns": {
        gridTemplateColumns: "auto auto",
      },
    },
    themeBtn: {
      "&.MuiButton-root": {
        // fontSize: ".938rem !important",
        "&.filled": {
          padding: ".75rem 1.125rem !important",
        },
      },
    },
    serviceIssues: {
      "&.MuiButtonBase-root": {
        fontSize: ".938rem",
      },
    },
  },

  [theme.breakpoints.down(564)]: {
    formCrossIcon: {
      top: "98px!important",
    },
  },

  [theme.breakpoints.down(550)]: {
    locationicon: {
      marginBottom: "25px !important",
    },

    checkBoxClass: {
      paddingTop: "20px",
    },
    checkBoxConfirm: {
      paddingTop: "0px",
    },
  },

  [theme.breakpoints.down(460)]: {
    calenderWrap: {
      "& .react-calendar__month-view__days": {
        gap: ".5rem",
        padding: "0.75rem 0.5rem",
      },
      "& button.react-calendar__tile": {
        fontSize: ".875rem",
        border: `0px solid `,
      },
      "& .react-calendar__navigation": {
        justifyContent: "center",
      },
      "& react-calendar__navigation button": {
        marginLeft: "0rem",
      },
    },
    timeSlotdiv: {
      background: "#F2F0FA",
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
      paddingTop: "1rem",
      paddingBottom: "0rem",
      height: "100%",
    },
    formDiv: {
      padding: "1.5rem 1rem",
    },
    radioBox: {
      "&.twoColumns": {
        gridTemplateColumns: "auto",
      },
      "&.threeColumns": {
        gridTemplateColumns: "auto",
      },
    },
    themeBtn: {
      "&.MuiButton-root": {
        fontSize: ".875rem !important",
        "&.serviceType": {
          // fontSize: "1rem",
          padding: ".5rem 1rem !important",
        },
      },
    },
  },
  [theme.breakpoints.down(380)]: {
    selectTimeSlotText: {
      display: "none",
    },
  },
  [theme.breakpoints.down(350)]: {
    ButtonAddress: {
      display: "-ms-flexbox",
      display: "-webkit-flex ",
      display: "flex",
      gap: "10px",
      flexDirection: "column",
    },
    formCrossIcon: {
      top: "75px!important",
    },
  },
}));

export default appointmentFormStyle;
